<template>
  <v-dialog
    v-model="show"
    scrollable
    :overlay="true"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.MARK_AS_PAID') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-form v-model="formValid">
          <v-container>
            <v-row class="d-flex align-center">
              <!-- App -->
              <v-col cols="12" sm="12">
                <v-menu
                  v-model="paymentDatePicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  :rules="paymentDateRules"
                  min-width="290px"
                  :menu-props="{ bottom: true, offsetY: true }"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="paidAt !== '' ? datePickerFormat(paidAt) : ''"
                      :label="
                        `${$vuetify.lang.t(
                          '$vuetify.ENFORCEMENT.FINE_PAYMENT_DATE'
                        )}*`
                      "
                      :placeholder="
                        $vuetify.lang.t(
                          '$vuetify.ENFORCEMENT.FINE_PAYMENT_DATE'
                        )
                      "
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      v-bind="attrs"
                      @click:append="paymentDatePicker = !paymentDatePicker"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="paidAt"
                    @input="paymentDatePicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- Paid amount -->
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model.number="paidAmount"
                  :label="
                    `${$vuetify.lang.t('$vuetify.ENFORCEMENT.PAID_AMOUNT')}*`
                  "
                  :placeholder="
                    $vuetify.lang.t('$vuetify.ENFORCEMENT.PAID_AMOUNT')
                  "
                  :rules="paidAmountRules"
                  outlined
                  hide-details
                  append-icon="mdi-cash"
                  type="number"
                ></v-text-field>
              </v-col>
              <!-- Comments -->
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="comments"
                  :label="$vuetify.lang.t('$vuetify.COMMENTS')"
                  hide-details
                  outlined
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="secondary--text"
          text
          :disabled="!formValid"
          @click="markFineAsPaid()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MarkParkingFineAsPaidDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    parkingFine: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formValid: false,
      paymentDatePicker: false,
      paidAt: new Date(new Date()).toISOString().substr(0, 10),
      paymentDateRules: [
        v =>
          v.length < 1 ||
          this.$vuetify.lang.t('$vuetify.ENFORCEMENT.PAYMENT_DATE_REQUIRED')
      ],
      paidAmount: this.parkingFine.lastAmountInCents / 100 || 0,
      paidAmountRules: [
        v =>
          v >= 1 ||
          this.$vuetify.lang.t('$vuetify.ENFORCEMENT.PAID_AMOUNT_REQUIRED')
      ],
      comments: ''
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    ...mapGetters('app', ['loading'])
  },
  watch: {
    formValid() {
      this.$emit(this.formValid ? 'valid' : 'invalid')
    }
  },
  methods: {
    ...mapActions('enforcement', ['putParkingFine']),
    markFineAsPaid() {
      this.putParkingFine({
        id: this.parkingFine.id,
        status: 'PAID',
        placeId: this.parkingFine.place.id,
        paidAmount: this.paidAmount,
        paymentDate: this.paidAt,
        comments: this.comments
      })
      this.close()
    },
    close() {
      this.show = false
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    }
  }
}
</script>
